"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_UNDERCONSTRUCTION_CONTEXT = exports.CHECKOUT_CONTEXT = void 0;
const styled_1 = require("./styled");
exports.CHECKOUT_CONTEXT = {
    font: "'DM Sans', sans-serif",
    secondaryFont: "'DM Sans', sans-serif",
    colors: {
        primary: '#000000',
        gray: '#8F95A3',
    },
    typography: {
        css: (0, styled_1.css) `
      color: black;
    `,
        h2: (0, styled_1.css) `
      font-size: 1rem;
      color: ${(theme) => theme.colors.gray.deep};
      letter-spacing: 0.15px;
      line-height: 150%;
      font-weight: 500;
    `,
        h3: (0, styled_1.css) `
      color: #000000;
      line-height: 150%;
      font-size: 1.375rem;
      letter-spacing: 0.15px;
    `,
    },
    buttons: {
        css: (0, styled_1.css) `
      height: 3.5rem;
      border-radius: 0.625rem;
      background-color: ${(theme) => theme.colors.gray};
      color: white;
      text-transform: none;
    `,
    },
    links: {
        css: (0, styled_1.css) `
      color: #3751ff;
      letter-spacing: 0.25px;
      font-size: 0.9375rem;
      line-height: 150%;
      text-decoration: underline;
    `,
    },
    inputs: {
        css: (0, styled_1.css) `
      padding: 0 0.875rem;
      height: 3.5rem;
      border-radius: 0.625rem;
      border: 1px solid #d2d8e2;
    `,
        textarea: {
            label: (0, styled_1.css) `
        top: 1rem;
        bottom: unset;
      `,
        },
        label: (0, styled_1.css) `
      cursor: text;
      color: ${(theme) => theme.colors.gray};
      z-index: 1;
      margin-left: 0.75rem;
      user-select: none;
      position: absolute;
      top: 0.0625rem;
      bottom: 0.0625rem;
      left: 0.875rem;
      display: flex;
      align-items: center;
      padding: 0.15rem;
      transition: 150ms all;
      font-size: 0.8125rem;
      color: ${(theme) => theme.colors.gray};
      margin: 0;
      text-transform: none;
      &.focus-visible,
      &.with-value {
        top: -0.625rem;
        bottom: unset;
        left: 0.5rem;
        padding: 0 0.25rem;
        background-color: white;
      }
      ${styled_1.styled.disabled `
        color: ${(theme) => theme.colors.gray.semilight.alpha(0.3)};
      `}
    `,
        checkbox: {
            css: (0, styled_1.css) `
        --active: ${(theme) => theme.colors.gray.semilight};
        height: 21px;
        width: 21px;
        padding: 0;
      `,
            label: (0, styled_1.css) `
        margin-left: 0.5rem;
      `,
        },
        choicegroup: {
            label: (0, styled_1.css) `
        height: 3.5rem;
        padding: 0 1rem;
        display: flex;
        align-items: center;
      `,
        },
    },
};
exports.TEMPLATE_UNDERCONSTRUCTION_CONTEXT = {
    modal: {
        backdrop: (0, styled_1.css) `
        background: ${(theme) => theme.background};
        backdrop-filter: none;
      `,
        css: (0, styled_1.css) `
        max-width: 45rem;
        border-radius: 0;
        > section {
          padding: 0 3rem 4rem 3rem;
        }
        button {
          min-width: 17.8125rem;
          height: 3.5rem;
          text-transform: uppercase;
          background: #000000;
          color: #ffffff;
        }
      `,
    },
    typography: {
        p: (0, styled_1.css) `
        text-transform: uppercase;
      `,
    },
    inputs: {
        css: (0, styled_1.css) `
        height: 3.5rem;
        border: 0.0625rem solid black;
        border-radius: ${(theme) => theme.radius.small};
        ${styled_1.styled.focus `
          border: 0.0625rem solid ${(theme) => theme.colors.primary};
          border-color: ${(theme) => theme.colors.primary};
          box-shadow: 0px 0px 0px 0.125rem black;
        `}
        ${styled_1.styled.disabled `
          opacity: 0.3;
        `}
      `,
        textarea: {
            label: (0, styled_1.css) `
          top: 1rem;
          bottom: unset;
        `,
        },
        label: (0, styled_1.css) `
        cursor: text;
        color: #000000;
        z-index: 1;
        font-size: 1rem;
        margin-left: 0.75rem;
        user-select: none;
        position: absolute;
        top: 0.0625rem;
        bottom: 0.0625rem;
        left: ${(theme) => theme.spacing.small};
        display: flex;
        align-items: center;
        padding: 0.15rem;
        transition: 150ms all;
        font-size: 1.0625rem;
        margin: 0;
        &.focus-visible,
        &.with-value {
          top: -0.625rem;
          bottom: unset;
          left: 0.5rem;
          font-size: 0.8125rem;
          padding: 0 0.25rem;
          background-color: white;
        }
        ${styled_1.styled.disabled `
          color: ${(theme) => theme.colors.gray.semilight.alpha(0.3)};
        `}
      `,
    },
};
